import { unionBy } from 'lodash';
import { ITender } from 'contexts/Tender';
import { IException } from '../contexts/Tender/types';

export const mergeExceptions = (formikTender: ITender, responseTender: ITender): ITender => {
  const tenderExceptions = Array.isArray(responseTender.exceptions)
    ? responseTender.exceptions
    : [];
  const formikExceptions = Array.isArray(formikTender.exceptions) ? formikTender.exceptions : [];

  let exceptions: IException[] = [];

  if (tenderExceptions.length === 0) exceptions = tenderExceptions;
  else if (formikExceptions.length === 0) exceptions = formikExceptions;
  else {
    const mergedExceptions: string[] = [];
    exceptions = tenderExceptions.map((exception: IException) => {
      const formikException = tenderExceptions.find(
        ({ tenderRestrictionsType }: IException) =>
          tenderRestrictionsType === exception.tenderRestrictionsType
      );

      if (formikException) {
        mergedExceptions.push(exception.tenderRestrictionsType);
      }

      const definitions = unionBy(
        exception.definitions,
        formikException ? formikException.definitions : [],
        'ruleId'
      );

      return { ...exception, definitions };
    });

    const unMergedExceptions = formikExceptions.filter(
      ({ tenderRestrictionsType }: IException) => !mergedExceptions.includes(tenderRestrictionsType)
    );

    exceptions = [...exceptions, ...unMergedExceptions];
  }

  return { ...formikTender, ...responseTender, exceptions: exceptions };
};
